<template>
  <div class="artwork-history-footer">
    <span class="artwork-history-footer__count"> {{ count }} </span>
    <div class="artwork-history-footer__button-container">
      <button
        type="button"
        class="artwork-history-footer__button artwork-history-footer__button--secondary"
        :class="{
          'artwork-history-footer__button--standard-artwork': isStandardArtwork
        }"
        @click="$emit('close')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="artwork-history-footer__button artwork-history-footer__button--primary"
        :class="{
          'artwork-history-footer__button--loading': isLoadingCta,
          'artwork-history-footer__button--standard-artwork': isStandardArtwork
        }"
        :disabled="isLoadingCta"
        @click="$emit('cta-action')"
      >
        {{ ctaText }}
        <Loader v-if="isLoadingCta" class="artwork-history-footer__loader" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import Loader from "common/vue/components/Loader.vue";
import { useDtfStore } from "./store";

export default {
  name: "ArtworkHistoryModalFooter",
  components: {
    Loader
  },
  props: {
    count: {
      type: String,
      required: true
    },
    isLoadingCta: {
      type: Boolean,
      required: true
    },
    ctaText: {
      type: String,
      required: true
    }
  },
  emits: ["close", "cta-action"],
  computed: {
    ...mapState(useDtfStore, ["isStandardArtwork"])
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.artwork-history-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  box-shadow: 0px -4px 6px -2px rgba($black-light, 0.08);

  &__count {
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: $crafterpay-gray-modern-700;
  }

  &__button-container {
    display: flex;
    gap: 10px;
  }

  &__button {
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 8px;
    padding: 7px 14px;
    border: 1px solid $borneo-pink-gradient-start;
    position: relative;

    &:disabled {
      opacity: 0.25;
      pointer-events: none;
    }

    &--secondary {
      color: $borneo-pink-gradient-start;
      background-color: $white;
    }

    &--secondary#{&}--standard-artwork {
      color: $primary-light;
      border-color: $primary-light;
    }

    &--primary {
      color: $white;
      background-color: $borneo-pink-gradient-start;
      min-width: 146px; // Avoid jumping between Design and Designs
    }

    &--primary#{&}--standard-artwork {
      border-color: $primary-light;
      background-color: $primary-light;
    }

    &--loading {
      color: transparent;
    }
  }

  &__loader {
    color: $white;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
